var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 80,
    viewBox: "0 0 171 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000217873 81.3872C6.59105 68.8198 10.3195 54.5154 10.3195 39.3402C10.3195 24.1652 6.59111 9.8609 0.000347295 -2.70647C15.1557 -31.6047 45.4459 -51.319 80.3405 -51.319C130.41 -51.319 171 -10.7293 171 39.3405C171 89.4104 130.41 130 80.3405 130C45.4457 130 15.1555 110.286 0.000217873 81.3872ZM80.3405 -8.88647C106.976 -8.88646 128.567 12.7055 128.567 39.3405C128.567 65.9755 106.976 87.5675 80.3405 87.5675C53.7055 87.5675 32.1135 65.9755 32.1135 39.3405C32.1136 12.7055 53.7055 -8.88647 80.3405 -8.88647Z",
    fill: "#3F81BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectBackground);
export default __webpack_public_path__ + "static/media/object_background.72a31e701fe9cd41bb4dd75422d597b2.svg";
export { ForwardRef as ReactComponent };